import React, {Component, PropTypes} from 'react'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import {errorStatus, infoStatus} from '../../../core/redux/status'
import LoaderButton from '../../../core/components/LoaderButton'
import i18n from '../../i18n'
import style from './PatrimonyUserModal.less'
import {
    sendSendActivationEmailDemand,
    sendDisableUserCmd,
} from '../../../company/actions'

import {
    loadContactStream,
    updateReferenceUserCmd,
    sendReferenceUserCmd,
    sendUpdateLoginCmd,
    getLogin,
    getPatrimonyUserState,
    sendLinkPatrimonyContactWithUser,
} from '../../actions'
import {connect} from 'react-redux'
import {linkFinder} from '../../../core/links'


const requiredLabel = (label) => (
    <span>{label} <i>*</i></span>
)

const getTitle = (contact) => {
    return i18n.patrimonyUser.title[getPatrimonyUserState(contact)]
}

const getModalBody = (contact) => {
    return ({
        NoAccount: ModalNoAccount,
        NotActiveAccount: ModalNotActiveAccount,
        ActiveAccount: ModalActiveAccount,
    })[getPatrimonyUserState(contact)]
}

const dispatchUpdateCmd = (props) => {
    const {dispatch, patrimonyContact, show} = props
    if (typeof show === 'boolean') {
        dispatch(updateReferenceUserCmd(show, patrimonyContact))
    }
}

class PatrimonyUserModal extends Component {
    static propTypes = {
        patrimonyContact: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired,
    }

    componentWillMount() {
        dispatchUpdateCmd(this.props)
    }

    componentWillReceiveProps(nextProps) {
        dispatchUpdateCmd(nextProps)
    }

    render() {
        const {patrimonyContact, onHide, dispatch, patrimonyUid, ...others} = this.props

        const ModalBody = getModalBody(patrimonyContact)
        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{getTitle(patrimonyContact)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalBody contact={patrimonyContact} onHide={onHide} dispatch={dispatch} patrimonyUid={patrimonyUid}/>
                </Modal.Body>
            </Modal>
        )
    }
}

// ActiveAccount: "Désactiver l'utilisateur" (juste un lien)
class ModalActiveAccount extends Component {
    onClick = (event) => {
        const {dispatch, onHide, contact} = this.props

        event.preventDefault()
        return dispatch(sendDisableUserCmd(contact.patrimonyUserState.userUid)).then(() => {
            return dispatch(loadContactStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        return (<div className={style.send}>
            <a onClick={this.onClick}>{i18n.user.disable}</a>
        </div>)
    }
}

class ValueComponent extends Component {
    state = {}

    componentWillMount() {
        this.setValue(getLogin(this.props.contact))
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setValue(getLogin(nextProps.contact))
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.value !== nextState.value
    }

    setValue(value) {
        this.setState({
            value: value
        })
    }

    onChange = (e) => {
        this.setValue(e.target.value)
    }
}

// NotActiveAccount: "Modifier le login" (input login + link renvoyer mail d'activation)
class ModalNotActiveAccount extends ValueComponent {
    _sendActivationEmail = (event) => {
        const {dispatch, onHide, contact} = this.props

        event.preventDefault()
        return dispatch(sendSendActivationEmailDemand(contact.patrimonyUserState.userUid)).then(() => {
            return dispatch(infoStatus(i18n.user.activationEmailSent))
        }).then(() => {
            onHide()
        })
    }

    _sendUpdateLoginCmd = () => {
        const {dispatch, onHide, contact} = this.props
        const {value} = this.state

        return dispatch(sendUpdateLoginCmd(contact.patrimonyUserState.userUid, value)).then(() => {
            return dispatch(loadContactStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {value} = this.state
        const {onHide} = this.props
        return (<div>
            <div>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='login'
                        label={requiredLabel(i18n.user.login)}
                        value={value}
                        onChange={this.onChange}
                    />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        onClick={this._sendUpdateLoginCmd}
                        bsSize='large'>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </div>
            <div className={style.send}>
                <a onClick={this._sendActivationEmail}>
                    {i18n.user.sendActivationEmail}
                </a>
            </div>
        </div>)
    }
}

// NoAccount: "Créer un compte utilisateur" input login
class ModalNoAccount extends ValueComponent {
    _end = () => {
        const {dispatch, onHide} = this.props
        onHide()
        setTimeout(() => dispatch(loadContactStream()), 1000)
    }
    _sendLink = () => {
        const {dispatch, contact, patrimonyUid} = this.props

        return dispatch(sendLinkPatrimonyContactWithUser(patrimonyUid, contact.uid)).then(this._end)
    }
    _sendCmd = () => {
        const {dispatch} = this.props
        const {value} = this.state

        return dispatch(sendReferenceUserCmd(value))
            .then((referenceCmdUserSent) => {
                const {status, errorType} = referenceCmdUserSent
                if (status === 400 && errorType === 'UserAlreadyExist') {
                    this.setState({error: true})
                    return Promise.resolve()
                } else if (status === 400) {
                    return errorStatus(errorType)
                }
                return this._sendLink()
            })
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return super.shouldComponentUpdate(nextProps, nextState, nextContext) || this.state.error !== nextState.error
    }

    render() {
        const {value, error} = this.state
        const {onHide} = this.props

        return (<div>
            <form className='form-horizontal'>
                <Input
                    labelClassName='col-sm-3'
                    wrapperClassName='col-sm-9'
                    type='text'
                    name='login'
                    value={value}
                    disabled={error}
                    onChange={this.onChange}
                    label={requiredLabel(i18n.user.login)}/>
            </form>
            <ButtonToolbar>
                {error ? <div>{i18n.patrimonyUser.linkToUserError}</div> : null}
                <LoaderButton
                    bsStyle='primary'
                    bsSize='large'
                    onClick={error ? this._sendLink : this._sendCmd}
                >
                    {error ? i18n.patrimonyUser.linkToUser : i18n.save}
                </LoaderButton>
                <Button
                    bsSize='large'
                    onClick={onHide}>
                    {i18n.cancel}
                </Button>
            </ButtonToolbar>
        </div>)
    }
}

PatrimonyUserModal = connect(state => ({
    patrimonyUid: state.patrimony.patrimony.uid
}))(PatrimonyUserModal)

export default PatrimonyUserModal


// WEBPACK FOOTER //
// ./lib/patrimony/components/patrimonycontact/PatrimonyUserModal.js